<template>
<e-chart ref="chart" />
</template>

<script>
// import {AXIS_LABEL, AXIS_LINE_STYLE, NUMBER_FONT_FAMILY} from './FactorCharts/chartStyle'
export default {
  name: 'AQIPolluteAnalysis',
  props: {
    data: {
      required: true,
      type: Array
    },
    screenWidth: {
      required: true,
      type: Number
    },
    screenHeight: {
      required: true,
      type: Number
    },
    query: {
      required: true,
      type: Object
    }
  },
  methods: {
    setPostion (dataIndex) {
      // 当前屏幕宽高， 是否聚合数据，站点Ids
      let {screenWidth, screenHeight, query: {isSiteMerge, siteIds}} = this
      // 默认宽高
      let defaultWidth = 300
      let defaultHeight = 250
      // N月
      let i = dataIndex + 1

      // 减去向左间隔60之后的实际日历图所剩宽度
      let width = screenWidth - 60
      // 站点数据的实际宽度 => 每个站平分
      if (!isSiteMerge) {
        width = (screenWidth / siteIds.length) - 60
      }
      // 减去Tool的高度之后的实际日历图所剩高度  站点数据的日历图不需要Tool
      let height = screenHeight - (isSiteMerge ? 100 : 50)
      // 计算按默认宽度每行能用几个日历图
      let computedW = width / defaultWidth

      // 最少每列1个日历图
      let col = Math.floor(computedW) <= 1 ? 1 : Math.floor(computedW)
      // 最多一行四个日历图
      if (col > 4) {
        col = 4
      }
      // 计算有 N 行日历图  最高12行
      let row = 12 / col
      // 向下取整 得出日历图宽高
      let h = Math.floor(height / row)
      let w = Math.floor(width / col)

      /**
       * 日历图第一行默认top为tool的高度
      */
      let top = (isSiteMerge ? 100 : 50)
      // 日历图为第一行以上 修改top值
      if (i / col >= 1) {
        // 日历图 N 行 top为 N行 * h + tool的高度  如果第N个日历图被列数整除 N行-1 * h + tool的高度
        top = i % col === 0 ? (i / col - 1) * h + (isSiteMerge ? 100 : 50) : Math.floor(i / col) * h + (isSiteMerge ? 100 : 50)

        // 如果 日历图高度低于150 则设置每个日历图的高度为默认高度 defaultHeight 从而计算top值
        if (h - 20 * row < 150) {
          top = i % col === 0 ? (i / col - 1) * defaultHeight + (isSiteMerge ? 100 : 50) : Math.floor(i / col) * defaultHeight + (isSiteMerge ? 100 : 50)
        }
      }

      // 设置left值 每行第一个日历图设置默认值为 60 否则为 i个日历图 + 列数 % 列数 取余为零 则 left值为 N列 * w + 60
      let left = (i + col) % col === 1 ? 60 : (((i + col) % col) === 0 ? (col - 1) * w + 60 : (((i + col) % col) - 1) * w + 60)

      return {
        top: top,
        left: left,
        width: w - 20 * col,
        height: h - 20 * row < 150 ? defaultHeight - 40 : h - 20 * row
      }
    },
    getHeatmapData () {
      let {data} = this

      return data.map((el, i) => {
        return {
          type: 'heatmap',
          coordinateSystem: 'calendar',
          calendarIndex: i,
          data: el.heatmapData
        }
      })
    },
    getLunarData () {
      let {data} = this
      let {screenWidth, query: {isSiteMerge, siteIds}} = this
      let defaultWidth = 300

      let width = screenWidth - 60
      if (!isSiteMerge) {
        width = (screenWidth / siteIds.length) - 60
      }

      let computedW = width / defaultWidth
      let col = computedW > 0 && Math.floor(computedW) <= 1 ? 1 : Math.floor(computedW)
      if (col > 4) {
        col = 4
      }
      let row = 12 / col

      return data.map((el, i) => {
        return {
          type: 'scatter',
          coordinateSystem: 'calendar',
          calendarIndex: i,
          symbolSize: 0,
          label: {
            show: true,
            formatter: function (params) {
              if (row > 3) {
                return new Date(params.value[0]).getDate() + '\n\n' + (params.value[2] ? params.value[2] : '')
              }
              return params.value[2] ? params.value[2] : ''
            },
            fontSize: 10,
            color: '#000'
          },
          tooltip: {
            formatter: function (param) {
              return `${param.value[0]} 主要污染物：${param.value[2] ? param.value[2] : '/'} > ${param.value[1] ? param.value[1] : '/'}`
            },
            borderColor: '#FFF'
          },
          data: el.lunarData
        }
      })
    },
    getCalendar () {
      // let {data} = this
      let data = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
      return data.map((el, index) => {
        let position = this.setPostion(index)

        return {
          ...position,
          orient: 'vertical',
          yearLabel: {
            show: false
          },
          dayLabel: {
            nameMap: 'cn'
          },
          monthLabel: {
            nameMap: 'cn',
            margin: 5
          },
          range: new Date(new Date(this.query.beginTime).format('YYYY'), index).format('YYYY-MM')
        }
      })
    },
    render (isReal) {
      let chartOpt = {
        title: {
          top: 0,
          left: 'center',
          text: new Date(this.query.beginTime).format('YYYY') + '年污染日历图（色阶为AQI）',
          show: this.query.isSiteMerge
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 10
        },
        tooltip: {},
        visualMap: [{
          show: this.query.isSiteMerge,
          type: 'piecewise',
          orient: 'horizontal',
          seriesIndex: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
          pieces: [
            {min: 300, color: '#7E0024'},
            {min: 200, max: 300, color: '#99004C'},
            {min: 150, max: 200, color: '#FF0000'},
            {min: 100, max: 150, color: '#FF7E00'},
            {min: 50, max: 100, color: '#FFFF00'},
            {min: 0, max: 50, color: '#00EE00'}
          ],
          left: 'center',
          top: 30
        }],
        calendar: this.getCalendar(),
        series: this.getHeatmapData().concat(this.getLunarData())
      }

      this.$refs.chart.setOpt(chartOpt)
      this.$refs.chart.resize()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/AQIPolluteAnalysis.vue